<tax-page-header
  [titleText]="isUserExist ? user?.name : 'user.add.user'"
  [dropdownItems]="dropdownItems"
>
  <div class="user-header">
    <div class="user-photo">
      {{ getFirstLetterOfName(userForm.value.name) }}
      <tax-icon *ngIf="user?.blockedAt" name="block" class="block-icon"></tax-icon>
    </div>
    <div class="user-date" data-qa-block="user-info">
      <div *ngIf="user?.lastActionDate" data-qa="last-action-date">
        {{ 'user.last.action.date' | translate }}
        {{ user?.lastActionDate | dateTime: { withSeconds: true } }}
      </div>
      <div *ngIf="user?.createdAt" data-qa="created-date">
        {{ 'user.created.date' | translate }}
        {{ user?.createdAt | dateTime: { withSeconds: true } }}
      </div>
      <div *ngIf="!isUserExist" translate>user.empty.avatar</div>
    </div>
  </div>
</tax-page-header>

<form
  class="ui-kit-content-container--with-separators user-container"
  (ngSubmit)="editUser(user)"
  [formGroup]="userForm"
  data-qa-form="user"
>
  <div class="ui-kit-rows-layout">
    <tax-input
      labelText="user.form.email"
      formControlName="email"
      data-qa-input="email"
      taxEmailValidator
      [autofocus]="true"
      [tabindex]="1"
      [layoutColumns]="2"
      [clearable]="true"
      errorText="user.form.incorrect.email"
      errorType="tooltip"
    ></tax-input>

    <div class="ui-kit-layout-columns-2 user__parameter--phone" *ngIf="isUserExist">
      <div class="required-marker" translate data-qa="input-label">organization.phone</div>
      <div class="phone" [class.grey-text]="!userForm.value.phone" data-qa="user-phone">
        {{ userForm.value.phone || ('user.form.phone.not.exist' | translate) }}
      </div>
      <div
        class="ui-kit-button_link column-2"
        data-qa-button="change-phone"
        (click)="setPhone()"
        *ngIf="!isDisallowEditPhone(user)"
      >
        {{ (userForm.value.phone ? 'button.change' : 'button.designate') | translate }}
      </div>
    </div>
    <tax-input
      taxNumbersOnly
      labelText="organization.iin"
      formControlName="iin"
      data-qa-input="iin"
      errorType="tooltip"
      [clearable]="true"
      [layoutColumns]="2"
      [tabindex]="2"
      [maxlength]="12"
    ></tax-input>
    <tax-phone-input
      *ngIf="!isUserExist"
      placeholder="login.sms.phone.placeholder"
      formControlName="phone"
      data-qa-input="phone"
      [clearable]="true"
      errorType="tooltip"
      [layoutColumns]="2"
      [width]="'50%'"
      [tabindex]="2"
    ></tax-phone-input>

    <tax-input
      [labelText]="'user.form.initials'"
      formControlName="name"
      data-qa-input="name"
      [clearable]="true"
      [layoutColumns]="2"
      [tabindex]="2"
    ></tax-input>

    <tax-input
      [labelText]="'user.form.position'"
      formControlName="position"
      data-qa-input="position"
      [clearable]="true"
      [layoutColumns]="2"
      [tabindex]="3"
    ></tax-input>
  </div>

  <div class="ui-kit-rows-layout" data-qa-block="cabinet-data">
    <div class="ui-kit-block-title" translate data-qa="title-block">user.form.office.access</div>
    <tax-input
      [labelText]="'user.form.login'"
      formControlName="login"
      data-qa-input="login"
      [clearable]="true"
      [descriptionText]="'user.form.login.description'"
      errorType="tooltip"
      [layoutColumns]="2"
      [tabindex]="4"
      [autocomplete]="false"
    ></tax-input>
    <tax-password
      [errorType]="'tooltip'"
      class="input-field"
      [labelText]="'user.form.new.password'"
      formControlName="secret"
      data-qa-input="secret"
      [descriptionText]="'user.form.new.password.description'"
      [descriptionRightSide]="descriptionAction"
      [layoutColumns]="2"
      [tabindex]="5"
      [autocomplete]="false"
    ></tax-password>
    <ng-template #descriptionAction>
      <button
        data-qa-button="generate-password"
        class="ui-kit-button_link"
        (click)="generatePassword()"
        translate
        type="button"
      >
        user.form.new.password.generator
      </button>
    </ng-template>

    <tax-password
      [errorType]="'tooltip'"
      class="input-field"
      [labelText]="'user.form.password.confirmation'"
      formControlName="confirmSecret"
      data-qa-input="confirmSecret"
      [layoutColumns]="2"
      [tabindex]="6"
    ></tax-password>

    <tax-password
      *ngIf="userForm.controls.oldSecret"
      class="input-field"
      [labelText]="'user.form.old.password'"
      formControlName="oldSecret"
      data-qa-input="oldSecret"
      [layoutColumns]="2"
      [tabindex]="7"
    ></tax-password>
  </div>
  <tax-user-permissions
    [selectedPermissions]="userForm.getRawValue().permissions"
    (selectedPermissionsChanged)="updatePermissionsValue($event)"
  ></tax-user-permissions>

  <tax-user-retail-places
    *ngIf="userForm.value.permissions && userForm.value.retailPlaces"
    [selectedRetailPlaces]="userForm.value.retailPlaces"
    [userPermissions]="userForm.getRawValue().permissions"
    (retailPlacesChanges)="updateSelectedRetailPlaces($event)"
    (toggleFullRetailPlaceAccess)="onToggleFullRetailPlaceAccess($event)"
  ></tax-user-retail-places>

  <tax-user-groups
    [selectedGroupsIds]="userForm.value.groupsIds"
    (groupsChanges)="updateSelectedGroups($event)"
  ></tax-user-groups>

  <div class="ui-kit-bottom-buttons-block">
    <button data-qa-button="go-back" class="back-button" (click)="back()" type="button" translate>
      group.back
    </button>
    <button data-qa-button="save-user" class="button_blue" [disabled]="userForm.invalid">
      {{ (isUserExist ? 'button.save' : 'button.add') | translate }}
    </button>
  </div>
</form>
